export default __webpack_public_path__ + "static/media/card-02.cc16070f.svg";